import { getRecentAuths } from "global/common/filtering";
import { gEnums } from "global/enums/globalEnums";
import _ from 'lodash';
import { useCallback, useContext, useState } from "react";
import { AppParentContext } from "../AppParentContext";
import { EventInfoContext } from "../EventInfoContext";
import { PapsContext } from "../PapsContext";
import { formatItem, formatTypes } from "global/common/dateFormatting";

const limit = 100
const _defaultDays = 14

export const useAppUserAuth = () => {

  const papsContext = useContext(PapsContext)
  const { paps_state } = papsContext ?? {}

  const eventInfoContext = useContext(EventInfoContext)
  const { eventInfo_state } = eventInfoContext ?? {}

  const appParentContext = useContext(AppParentContext)
  const { fn_cls } = appParentContext ?? {}

  const { appProfileData } = eventInfo_state ?? {}
  const { pathViews } = paps_state ?? {}

  const [processing, setProcessing] = useState()

  const ammendResults = (result) => {
    const { found, appUserAuths } = result ?? {}
    if (found && appUserAuths) {
      const recent = getRecentAuths(found, _defaultDays)
      Object.keys(appUserAuths).forEach((key) => {
        const appUserAuth = appUserAuths[key]
        const { email } = appUserAuth
        const _af = email ? _.find(found, { email: email.toLowerCase() }) : null
        const _ar = email ? _.find(recent, { email: email.toLowerCase() }) : null
        appUserAuth.foundType = gEnums.authListTypes.notFound
        if (_af) { appUserAuth.foundType = gEnums.authListTypes.found }
        if (_ar) { appUserAuth.foundType = gEnums.authListTypes.recent }
        if (_af || _ar) {
          appUserAuth.metadata = _af.metadata
        }
      })
      const appUserAuthList = _.groupBy(appUserAuths, 'foundType')
      const counts = {
        total: _.size(appUserAuths),
        recent: appUserAuthList?.recent ? _.size(appUserAuthList.recent) : 0,
        found: appUserAuthList?.found ? _.size(appUserAuthList.found) : 0,
        notFound: appUserAuthList?.notFound ? _.size(appUserAuthList.notFound) : 0
      }

      const safePercent = (value, total) => {
        if (!total || !value) return 0
        return Number(((value / total) * 100).toFixed(2))
      }

      const percents = {
        recent: safePercent(counts.recent, counts.total),
        found: safePercent(counts.found, counts.total),
        notFound: safePercent(counts.notFound, counts.total),
      }

      const totals = { counts, percents }
      return { appUserAuthList, totals }
    }
    return {}
  }

  const getAppUserAuths = useCallback((callback, appProfiles) => {
    const cb = (res) => {
      const { appUserAuthList, totals } = ammendResults(res)
      const usageData = ammendUsageData(appUserAuthList, appProfiles)
      setProcessing(null)
      callback(appUserAuthList, totals, usageData)
    }
    console.clear()
    setProcessing(true)
    if (!appProfiles) {
      console.log('No appProfiles')
    }

    if (appProfiles) {
      const _sau = _.sortBy(appProfiles, 'lastName')
      const chunks = _.chunk(_sau, limit);
      fn_cls.getAuthsByChunkEmail(chunks, pathViews, true, cb, appProfiles)
    } else {
      console.log('No appProfiles')
      setProcessing(null)
      callback({})
    }
  }, []);

  return { getAppUserAuths, processing };
};

const ammendUsageData = (appUserAuthList, profileData) => {
  const { recent, found, notFound } = appUserAuthList
  Object.keys(profileData).forEach(dik => {
    const r = recent ? _.find(recent, function (i) { return (i._itemKey === dik) || (i.email === dik) }) : null
    const f = found ? _.find(found, function (i) { return (i._itemKey === dik) || (i.email === dik) }) : null
    const nf = notFound ? _.find(notFound, function (i) { return (i._itemKey === dik) || (i.email === dik) }) : null
    if (r && r.metadata) { profileData[dik].metadata = { recent: true, ...r.metadata } }
    if (f && f.metadata) { profileData[dik].metadata = { found: true, ...f.metadata } }
    if (nf) { profileData[dik].metadata = { notFound: true } }
  })
  // handleCurrentDataItems(dataItems)
  const usageData = {
    recent: getOtherStuff(recent),
    found: getOtherStuff(found)
  }
  return usageData
}


const getOtherStuff = (items) => {
  const { lastRefresh, lastSignInTime } = countsByDate(items)
  const stds_lastRefresh = getMonthStarts(lastRefresh)
  const stds_lastSignInTime = getMonthStarts(lastSignInTime)
  return { startDates: { lastRefresh: stds_lastRefresh, lastSignInTime: stds_lastSignInTime }, authDates: { lastRefresh, lastSignInTime } }
}

const countsByDate = (appUsers) => {
  const _lastRefresh = _(appUsers)
    .groupBy((user) => {
      if (!user?.metadata?.lastRefreshTime) return 'not_authed';
      return formatItem(formatTypes.shortestDate, user.metadata.lastRefreshTime)
    })
    .mapValues((users) => users.length)
    .value();

  const appUsers_lastRefresh = {}
  _.forEach(_lastRefresh, (item, itemKey) => {
    appUsers_lastRefresh[itemKey] = {
      count: item
    }
  })

  const _lastSignInTime = _(appUsers)
    .groupBy((user) => {
      if (!user?.metadata?.lastSignInTime) return 'not_authed';
      return formatItem(formatTypes.shortestDate, user.metadata.lastSignInTime)
    })
    .mapValues((users) => users.length)
    .value();
  const appUsers_lastSignInTime = {}
  _.forEach(_lastSignInTime, (item, itemKey) => {
    appUsers_lastSignInTime[itemKey] = {
      count: item
    }
  })
  return { lastRefresh: appUsers_lastRefresh, lastSignInTime: appUsers_lastSignInTime }
}

const getMonthStarts = (authDates) => {
  const months = new Set();

  Object.keys(authDates).forEach(d => {
    const [mm, , yyyy] = d.split('/');
    months.add(`${yyyy}-${mm}-01`); // normalize for sorting
  });

  return [...months]
    .sort((a, b) => new Date(a) - new Date(b))
    .map(d => {
      const [yyyy, mm] = d.split('-');
      return `${mm}/01/${yyyy}`;
    });
};